import { render, staticRenderFns } from "./CompareHeadlineCanvasGlowy.vue?vue&type=template&id=0ac0f945&scoped=true&"
import script from "./CompareHeadlineCanvasGlowy.vue?vue&type=script&lang=js&"
export * from "./CompareHeadlineCanvasGlowy.vue?vue&type=script&lang=js&"
import style0 from "./CompareHeadlineCanvasGlowy.vue?vue&type=style&index=0&id=0ac0f945&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0f945",
  null
  
)

export default component.exports